import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { historyEmployee } from "../../../services/UserService";
import ReactDatePicker from "react-datepicker";
import dayjs from "dayjs";
import currencyBRFormat from "../../../util/CurrencyUtils";

export const HistoricoServicosUsuario = (props) => {
  const [isOpen, setIsOpen] = useState(true);
  const [filterDate, setFilterDate] = useState(new Date());
  const [employeeHistory, setEmployeeHistory] = useState([]);

  useEffect(() => {
    setIsOpen(props.openHistory);
    historyEmployee(props.employee.id, dayjs(filterDate).format("YYYY-MM-DD"))
      .then((response) => {
        setEmployeeHistory(response || []);
      })
      .catch((error) => console.error(error));
  }, [filterDate, props.employee.id, props.openHistory]);

  const toggle = () => {
    props.setOpenHistory(false);
  };

  const totalComissionsSum = employeeHistory.reduce(
    (acc, curr) => acc + parseFloat(curr.servicesComission || 0),
    0
  );

  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop="static"
        size="lg"
        centered
      >
        <ModalHeader toggle={toggle} className="border-0 pb-0">
          <span className="fw-bold">Histórico de Produção</span>
        </ModalHeader>

        <ModalBody className="pt-3">
          {/* Grid de Informações */}
          <div className="row g-3 mb-4">
            <div className="col-12 col-md-7 col-lg-8">
              <div className="d-flex align-items-center bg-light p-2 px-3 rounded-3 h-100">
                <div 
                  className="bg-primary-subtle text-primary rounded-circle d-flex align-items-center justify-content-center me-3 fw-bold flex-shrink-0" 
                  style={{ width: '42px', height: '42px', fontSize: '1rem' }}
                >
                  {props.employee.name.charAt(0).toUpperCase()}
                </div>
                <div className="min-w-0">
                  <h6 className="fw-bold text-dark mb-1 text-truncate">{props.employee.name}</h6>
                  <span className="badge bg-success-subtle text-success border border-success-subtle rounded-pill" style={{ fontSize: '0.72rem' }}>
                    Comissão: {props.employee.comission}%
                  </span>
                </div>
              </div>
            </div>

            {/* Input de Data (Z-Index alto para o calendário flutuar sobre a tabela) */}
            <div className="col-12 col-md-5 col-lg-4" style={{ position: "relative", zIndex: 10 }}>
              <div className="d-flex flex-column justify-content-end">
                <label className="small fw-bold text-muted mb-1">Data da Consulta</label>
                <div className="w-100">
                  <ReactDatePicker
                    showIcon
                    icon="fa-regular fa-calendar-days text-primary"
                    className="form-control form-control-sm w-100"
                    dateFormat="dd/MM/yyyy"
                    locale="pt-BR"
                    selected={filterDate}
                    onChange={(date) => setFilterDate(date)}
                    maxDate={new Date()}
                    todayButton="Hoje"
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          {employeeHistory && employeeHistory.length > 0 ? (
            
            /* Container com rolagem vertical controlada */
            <div 
              className="border rounded-3 overflow-auto" 
              style={{ maxHeight: '320px', WebkitOverflowScrolling: 'touch' }}
            >
              <table className="table table-borderless alcon-table mb-0 align-middle table-sm">
                
                {/* 1. CABEÇALHO FIXO (Fundo Branco Sólido) */}
                <thead className="sticky-top border-bottom" style={{ position: "sticky", top: 0, zIndex: 2 }}>
                  <tr className="text-nowrap">
                    <th className="py-2.5 px-3 text-muted small fw-bold text-uppercase bg-white">Serviços</th>
                    <th className="py-2.5 text-end text-muted small fw-bold text-uppercase bg-white">Total</th>
                    <th className="py-2.5 text-end px-3 text-muted small fw-bold text-uppercase bg-white">Comissão</th>
                  </tr>
                </thead>
                
                {/* 2. CONTEÚDO SCROLLABLE */}
                <tbody>
                  
                  {employeeHistory.map((h, index) => (
          
                    <tr key={h.id}>
                      <td className="fw-medium text-dark py-2.5 px-3 small">{h.servicesNames}</td>
                      <td className="text-end text-muted small py-2.5">{currencyBRFormat(h.servicesTotal)}</td>
                      <td className="text-end px-3 fw-bold text-success py-2.5 small">
                        {currencyBRFormat(h.servicesComission)}
                      </td>
                    </tr>
                  ))}
                </tbody>

                {/* 3. RODAPÉ DE TOTAL ACUMULADO FIXO (Fundo Cinza Sólido) */}
                <tfoot className="sticky-bottom border-top" style={{ position: "sticky", bottom: 0, zIndex: 2 }}>
                  <tr className="table-light">
                    <td className="fw-bold text-dark py-3 px-3 bg-light" style={{ borderTop: "1px solid #dee2e6" }}>Total Acumulado</td>
                    <td className="bg-light" style={{ borderTop: "1px solid #dee2e6" }}></td>
                    <td className="text-end px-3 py-3 fw-bold text-success bg-light" style={{ fontSize: '1rem', borderTop: "1px solid #dee2e6" }}>
                      {currencyBRFormat(totalComissionsSum)}
                    </td>
                  </tr>
                </tfoot>

              </table>
            </div>
          ) : (
            /* Empty State */
            <div className="text-center py-5 text-muted bg-light rounded-3">
              <i className="fa-regular fa-calendar-xmark fs-1 mb-3 text-secondary d-block"></i>
              <span>
                Nenhum serviço registrado para <strong>{props.employee.name}</strong> em{" "}
                <strong>{dayjs(filterDate).format("DD/MM/YYYY")}</strong>.
              </span>
            </div>
          )}
        </ModalBody>

        <ModalFooter className="border-0 pt-0">
          <button type="button" onClick={toggle} className="btn btn-outline-secondary w-100 w-sm-auto">
            Fechar
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default HistoricoServicosUsuario;